
import log from "@/util/log";
export default {
  name: "CreateVoltage",
  data() {
    return {
      newVoltage: {
        description: "", //描述
        flavorId: [], //口味ID
        modeName: "", //模式名称
        nfcSettings: 0, //nfc开关
        preheatSetting: 0, //设置开关
        preheatTime: 0, //设置描述
        preheatVoltage: 0, //设置电压
        temperature: "", //温度曲线
      },
      voltageCurve: [-2100, -2100, -2100, -2100, -2100, -2100],
      flavorList: [],
      checkFlavorList: [], //选中未确定口味列表
      selectFlavorList: [], //选中已确定口味列表
      showFlavorPopup: false,
      activeSetting: "",
      beForm: "",
      divSetting: {},
      editId: "",
      model: "create", //create or edit
    };
  },
  created() {
    this.$api.writer.selectAllFlavor({}).then((res) => {
      if (res.code == 200) {
        if (res.data) {
          res.data.forEach((element) => {
            element.checked = false;
          });
          this.flavorList = res.data;
        }
      } else {
        this.$toast({
          type: "fail",
          duration: "2000",
          position: "middle",
          message: res.message,
        });
        this.flavorList = [];
      }
    });
  },
  mounted() {
    this.activeSetting = this.$route.params;
    this.beForm = this.$route.params.beForm;
    this.divSetting = this.$route.params.divSetting;
    this.editId = this.$route.params.editId;
    this.model = this.$route.params.model;

    if (this.model === "edit") {
      this.$api.writer
        .selectCurveById({
          id: this.editId,
        })
        .then((res) => {
          if (res.code === 200) {
            this.newVoltage.id = res.data.id;
            this.newVoltage.modeName = res.data.modeName;
            this.newVoltage.description = res.data.description;
            this.newVoltage.flavorId = res.data.flavorId;
            this.newVoltage.nfcSettings = res.data.nfcSettings.toString();
            this.newVoltage.preheatSetting = res.data.preheatSetting.toString();
            this.newVoltage.preheatTime = res.data.preheatTime;
            this.newVoltage.preheatVoltage = res.data.preheatVoltage;
            this.newVoltage.temperature = res.data.temperature;

            if (res.data.flavorId.length > 0) {
              res.data.flavorId.forEach((element) => {
                this.flavorList.forEach((item) => {
                  if (element.toString() === item.id.toString()) {
                    this.selectFlavorList.push(item);
                  }
                });
              });
            }

            let curveList = res.data.temperature.split(",");
            let newVoltageList = [];
            curveList.forEach((element) => {
              newVoltageList.push(parseInt(element) * -1);
            });
            this.voltageCurve = newVoltageList;
          } else {
            this.$toast({
              type: "fail",
              duration: "2000",
              forbidClick: "true",
              position: "middle",
              message: res.message,
            });
            setTimeout(() => {
              this.back();
            }, 2000);
          }
        })
        .catch((error) => {
          this.$toast({
            type: "fail",
            duration: "2000",
            forbidClick: "true",
            position: "middle",
            message: error.message,
          });
          setTimeout(() => {
            this.back();
          }, 2000);
        });
    }

    if (this.divSetting) {
      this.voltageCurve = this.divSetting.diyVoltage;
      this.newVoltage.nfcSettings = this.divSetting.isSupportNfc ? "1" : "0";
      this.newVoltage.preheatSetting = this.divSetting.isSupportPreheat
        ? "1"
        : "0";
      this.newVoltage.preheatTime = this.divSetting.preheatTime;
      this.newVoltage.preheatVoltage = this.divSetting.preheatVoltage;
      this.newVoltage.temperature = this.divSetting.diyVoltage.toString();
    }

    //挂载成功后给pop事件绑定一个方法
    // 如果支持 popstate （一般移动端都支持）
    if (window.history && window.history.pushState) {
      // 往历史记录里面添加一条新的当前页面的url
      history.pushState(null, null, document.URL);
      // 给 popstate 绑定一个方法用来监听页面返回
      window.addEventListener("popstate", this.back, false); //false阻止默认事件
    }
  },
  destroyed() {
    window.removeEventListener("popstate", this.back, false); //false阻止默认事件
  },
  watch: {},
  computed: {},
  methods: {
    back() {
      this.$router.replace({
        name: this.beForm == "Home" ? "Home" : "Settings",
        params: {
          activeSetting: "mySettings",
        },
      });
    },
    onClickHeaderReturn() {
      this.$router.replace({
        name: this.beForm == "Home" ? "Home" : "Settings",
        params: {
          activeSetting: "mySettings",
        },
      });
    },
    onTouchmoveVoltage(e) {},
    onChangeVoltageCurve(index) {},
    onClickModelItem(index) {},
    onClickSave() {
      if (this.$utils.isNullAndEmpty(this.newVoltage.modeName)) {
        this.$toast({
          type: "fail",
          duration: "2000",
          position: "middle",
          message: "Name cannot be empty.",
        });
        this.$refs.modeName.focus();
        return;
      }
      if (this.$utils.isNullAndEmpty(this.newVoltage.description)) {
        this.$toast({
          type: "fail",
          duration: "2000",
          forbidClick: "true",
          position: "middle",
          message: "Description cannot be empty.",
        });
        this.$refs.description.focus();
        return;
      }
      if (this.model === "edit") {
        this.$api.writer
          .updateVoltageName({
            id: this.newVoltage.id,
            modeName: this.newVoltage.modeName,
            heatingRemarks: this.newVoltage.description,
          })
          .then((res) => {
            if (res.code === 200) {
              //处理缓存
              let selectVoltage = JSON.parse(
                window.localStorage.getItem("selectVoltage")
              );
              if (selectVoltage) {
                selectVoltage.forEach((element) => {
                  if (element.id.toString() === this.newVoltage.id.toString()) {
                    element.modeName = this.newVoltage.modeName;
                  }
                });
                window.localStorage.setItem(
                  "selectVoltage",
                  JSON.stringify(selectVoltage)
                );
              }
              this.$toast({
                type: "success",
                duration: "2000",
                position: "middle",
                forbidClick: "true",
                message: res.message,
              });
              setTimeout(() => {
                this.$router.replace({
                  name: "Settings",
                  params: {
                    activeSetting: "mySettings",
                  },
                });
              }, 2000);
            } else {
              this.$toast({
                type: "fail",
                duration: "2000",
                position: "middle",
                message: res.message,
              });
            }
          })
          .catch((error) => {
            log(error);
          });
      } else {
        //处理电压曲线
        let newCurveList = this.voltageCurve.map((item) => Math.abs(item));
        if (newCurveList.length <= 6) {
          newCurveList.push(newCurveList[newCurveList.length - 1]);
          newCurveList.push(newCurveList[newCurveList.length - 1]);
        }
        this.newVoltage.temperature = newCurveList.toString();
        this.$api.writer.saveVoltageSettings(this.newVoltage).then((res) => {
          if (res.code == 200) {
            this.$toast({
              type: "success",
              duration: "1500",
              position: "middle",
              forbidClick: "true",
              message: res.message,
            });
            setTimeout(() => {
              this.$router.replace({
                name: "Settings",
                params: {
                  activeSetting: "mySettings",
                },
              });
            }, 1500);
          } else {
            this.$toast({
              type: "fail",
              duration: "2000",
              position: "middle",
              message: res.message,
            });
          }
        });
      }
    },
    onClickDome() {
      this.selectFlavorList = this.checkFlavorList;
      let idList = [];
      if (this.selectFlavorList.length > 0) {
        this.selectFlavorList.forEach((element) => {
          idList.push(element.id);
        });
      }
      this.newVoltage.flavorId = idList;
      this.showFlavorPopup = false;
    },
    onClickFlavorCheck(row, index) {
      if (this.checkFlavorList.length >= 5 && !row.checked) {
        this.$toast({
          type: "fail",
          duration: "2000",
          position: "middle",
          message: "Up to 5 can be selected.",
        });
        return;
      }
      row.checked = !row.checked;
      if (this.checkFlavorList.some((item) => item.id == row.id)) {
        this.checkFlavorList.splice(
          this.checkFlavorList.findIndex((item) => item.id == row.id),
          1
        );
      } else {
        this.checkFlavorList.push(row);
      }
    },
  },
};
